module.exports = __webpack_public_path__ + "img/sinclair catalog 1984 p7.dee62487.jpg";